/**
 * 韶音运输业务类型，与后端 {@code ShokzTransportModeEnum} 及运输委托单共用。
 */
export const SHOKZ_TRANSPORT_MODE = {
  SEA_FCL: 1,
  SEA_LCL: 2,
  AIR: 3,
  LAND: 4,
  RAILWAY: 5,
  EXPRESS: 6,
  SEA_RORO: 7,
  SEA_BULK: 8,
  OTHER: 9
} as const

export type ShokzTransportModeCode =
  typeof SHOKZ_TRANSPORT_MODE[keyof typeof SHOKZ_TRANSPORT_MODE]

const SHOKZ_TRANSPORT_MODE_I18N_SUFFIX: Record<number, string> = {
  [SHOKZ_TRANSPORT_MODE.SEA_FCL]: 'enums.transportMode.fcl',
  [SHOKZ_TRANSPORT_MODE.SEA_LCL]: 'enums.transportMode.lcl',
  [SHOKZ_TRANSPORT_MODE.AIR]: 'enums.transportMode.air',
  [SHOKZ_TRANSPORT_MODE.LAND]: 'enums.transportMode.road',
  [SHOKZ_TRANSPORT_MODE.RAILWAY]: 'enums.transportMode.rail',
  [SHOKZ_TRANSPORT_MODE.EXPRESS]: 'enums.transportMode.express',
  [SHOKZ_TRANSPORT_MODE.SEA_RORO]: 'enums.transportMode.roro',
  [SHOKZ_TRANSPORT_MODE.SEA_BULK]: 'enums.transportMode.bulk',
  [SHOKZ_TRANSPORT_MODE.OTHER]: 'enums.transportMode.other'
}

/** 运输委托单 i18n 模块前缀 */
export const SHOKZ_TRANSPORT_MODE_I18N_PREFIX = 'transportConsignment'

/**
 * 构建运输业务类型下拉选项。
 *
 * @param translate 传入 {@code t('transportConsignment.xxx')} 形式的翻译函数
 */
export function createShokzTransportModeOptions(
  translate: (key: string) => string
) {
  return Object.entries(SHOKZ_TRANSPORT_MODE_I18N_SUFFIX).map(([value, suffix]) => ({
    value: Number(value),
    label: translate(`${SHOKZ_TRANSPORT_MODE_I18N_PREFIX}.${suffix}`)
  }))
}

/**
 * 按编码返回运输业务类型展示文案。
 *
 * @param mode 运输业务类型编码
 * @param translate 传入 {@code t} 函数
 */
export function getShokzTransportModeLabel(
  mode: number | string | null | undefined,
  translate: (key: string) => string
) {
  const numericMode = Number(mode)
  const suffix = SHOKZ_TRANSPORT_MODE_I18N_SUFFIX[numericMode]
  return suffix
    ? translate(`${SHOKZ_TRANSPORT_MODE_I18N_PREFIX}.${suffix}`)
    : String(mode ?? '')
}

/**
 * 构建与运输委托单列表一致的枚举映射。
 *
 * @param translate 传入 {@code tc} 或等价翻译函数
 */
export function createShokzTransportModeEnumMap(
  translate: (key: string) => string
): Record<number, string> {
  return Object.fromEntries(
    createShokzTransportModeOptions(translate).map(item => [item.value, item.label])
  )
}
